<div class="empty-state-container">
  @switch (presentIllustration) {
    @case (EmptyStateIllustrationEnum.Bird) {
      <gb-empty-state-bird class="illustration"></gb-empty-state-bird>
    }
    @case (EmptyStateIllustrationEnum.Bag) {
      <gb-empty-state-bag class="illustration"></gb-empty-state-bag>
    }
    @case (EmptyStateIllustrationEnum.Cat) {
      <gb-empty-state-cat class="illustration"></gb-empty-state-cat>
    }
    @case (EmptyStateIllustrationEnum.Date) {
      <gb-empty-state-date class="illustration"></gb-empty-state-date>
    }
    @case (EmptyStateIllustrationEnum.Planet) {
      <gb-empty-state-planet class="illustration"></gb-empty-state-planet>
    }
    @case (EmptyStateIllustrationEnum.Fridge) {
      <gb-empty-state-fridge class="illustration"></gb-empty-state-fridge>
    }
    @case (EmptyStateIllustrationEnum.Cat) {
      <gb-empty-state-cat class="illustration"></gb-empty-state-cat>
    }
  }

  <div class="text-container">
    @if (titleTranslateKey) {
      <h2 [translate]="titleTranslateKey"></h2>
    }
    @if (subtitle) {
      <span [translate]="subtitle"></span>
    }
    <div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
